import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgBox = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-box';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M8.3 5.247a1268 1268 0 0 0-3.655 2.096c-.008.007.067.153.166.325l.18.312-.375.011-.376.012v8.431l3.68 2.103a508 508 0 0 0 3.697 2.103c.01 0 .094-.135.188-.3s.182-.3.195-.3.101.135.195.3.178.3.188.3 1.673-.946 3.697-2.103l3.68-2.103V8.003l-.376-.012-.375-.011.18-.312c.099-.172.174-.318.166-.325-.072-.064-7.327-4.182-7.365-4.181-.027.002-1.688.94-3.69 2.085m6.43 1.182c1.491.851 2.706 1.562 2.7 1.58-.011.034-5.381 3.111-5.43 3.111S6.581 8.043 6.57 8.009C6.561 7.982 11.944 4.88 12 4.88c.01 0 1.239.697 2.73 1.549m-6.225 4.442 2.715 1.552.01 3.132c.007 1.978-.004 3.127-.028 3.118-.021-.007-1.253-.706-2.739-1.553l-2.7-1.54-.002-3.13c0-1.722.006-3.13.014-3.13s1.237.698 2.73 1.551m9.734 1.579-.002 3.13-2.7 1.54a341 341 0 0 1-2.739 1.553c-.024.009-.035-1.14-.028-3.118l.01-3.132 2.7-1.548a219 219 0 0 1 2.73-1.551c.017-.002.029 1.404.029 3.126"
    })
  }));
});
export default SvgBox;